import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import objFromArray from 'src/utils/objFromArray';

const initialState = {
  byId: {},
  allIds: [],
};

const slice = createSlice({
  name: 'courts',
  initialState,
  reducers: {
    getCourts(state, action) {
      const courts = action.payload;

      state.byId = objFromArray(courts);
      state.allIds = Object.keys(state.byId);
    },
    createCourt(state, action) {
      const courts = action.payload;

      state.byId = objFromArray(courts);
      state.allIds = Object.keys(state.byId);
    },
  },
});

export const reducer = slice.reducer;

export const getCourts = () => async (dispatch) => {
  const response = await axios.get('/api/courts/');

  dispatch(slice.actions.getCourts(response.data));
};

export const createCourt = (data) => async (dispatch) => {
  const response = await axios.post('/api/courts/', data);

  console.log(response, 'response');

  dispatch(slice.actions.createCourt(response.data));
};

export default slice;
